import { createContext, useContext, useMemo } from 'react';
import { useRoutes } from './use-routes';
import { usePermissions } from '../../hooks/use-permissions';

const Context = createContext();

export const useAdminContext = () => useContext(Context);

export function Provider({ children }) {
  const routes = useRoutes();
  const permissions = usePermissions();

  const hasAccess = useMemo(
    () => (permissions?.length ? Boolean(routes.length) : undefined),
    [permissions, routes],
  );

  const state = useMemo(() => ({ hasAccess, routes }), [hasAccess, routes]);

  return <Context.Provider value={state}>{children}</Context.Provider>;
}
